import itemStyle from './line.data.emphasis.itemStyle'
import label from './line.data.emphasis.label'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "单个拐点的高亮样式和标签设置。",
  type: "object",
  props: {
    itemStyle,
    label,
  },
}
